export default __webpack_public_path__ + "static/media/rancho2big_thumb.6e1e8ba2.jpg";